export default __webpack_public_path__ + "static/media/adobe-tech-4.7b3ce9cc.png";